import * as ss from 'superstruct';

/** A platform-neutral summary of what an ad shows. */
export const AdCreative = ss.type({
  headlines: ss.optional(ss.array(ss.string())),
  descriptions: ss.optional(ss.array(ss.string())),
  title: ss.optional(ss.string()),
  body: ss.optional(ss.string()),
  imageUrls: ss.optional(ss.array(ss.string())),
  callToAction: ss.optional(ss.string()),
});

export type AdCreative = ss.Infer<typeof AdCreative>;
